export interface SgmeErrorResponse<T = unknown> {
  httpError: {
    error: T;
  };
}

export function isSgmeErrorResponse(val?: any): val is SgmeErrorResponse<unknown> {
  return (val as SgmeErrorResponse | undefined)?.httpError?.error !== undefined;
}
